<template>
    <button class="btn group-hover:bg-accent-yellow-darker" :class="buttonClasses">
        <span v-if="active">{{ lang('Dölj', 'Hide') }}</span>
        <span v-else>{{ lang('Visa', 'Show') }}</span>
    </button>
</template>

<script>
    export default {
        props: {
            buttonClasses: {
                type: String,
                default: '',
            },
            active: {
                type: Boolean,
                required: true,
            },
        },
    };
</script>
